let element
let lastScrollTop = 0

export function init() {
	element = document.getElementById('scroll-top')

	if (element) {
		element.addEventListener('click', event => {
			event.preventDefault()
			window.scrollTo({ top: 0, behavior: 'smooth' })
			element.blur()
		})

		window.addEventListener('scroll', handleScroll)
		handleScroll()
	}
}

function handleScroll() {
	const scrollDirection = lastScrollTop > window.scrollY ? 'up' : 'down'

	// Hide scrollTop button if already at top of page or scrolling down
	if (window.scrollY === 0 || scrollDirection === 'down') {
		element.classList.add('is-hidden')
	} else {
		element.classList.remove('is-hidden')
	}

	lastScrollTop = window.scrollY
}
